import React from 'react';
import { Button } from '../ui/button';
import { useChatbot } from '../../contexts/ChatbotContext';
import { cn } from '../../lib/utils';
import botsIcon from '../../assets/img3d/Avatar.png';

/**
 * ChatbotButton Component
 * Button to open the chatbot
 * Supports two variants:
 * - 'floating': Fixed position bottom right (for homepage)
 * - 'sidebar': Positioned above taskbar (for admin/client/pro pages)
 */
const ChatbotButton = ({ variant = 'floating' }) => {
  const { isOpen, openChatbot } = useChatbot();

  // Don't show if chatbot is open
  if (isOpen) return null;

  // Positionnement pour sidebar (utilisé dans la taskbar)
  // - centré horizontalement dans la taskbar
  // - posé sur le bord supérieur sans être rogné au scroll
  const sidebarClasses = "absolute -top-6 md:-top-20 left-1/2 -translate-x-1/2 transform z-50";
  
  // Positionnement pour floating (bouton flottant, utilisé sur la page d'accueil)
  const floatingClasses = "fixed bottom-6 right-6 z-40";
  const containerClasses = variant === 'floating' ? floatingClasses : sidebarClasses;

  return (
    <div className={containerClasses}>
      <Button
        onClick={() => openChatbot()}
        className={cn(
          // Taille augmentée, responsive (plus grande qu'avant)
          "h-20 w-20 md:h-24 md:w-24",
          // Style minimaliste, sans fond parasite
          "rounded-full bg-transparent hover:bg-transparent p-0 shadow-none border-0 overflow-hidden",
          // Hover identique partout
          "hover:scale-110 transition-transform",
          // Animation uniquement sur la homepage (variant 'floating')
          variant === 'floating' &&
            "motion-safe:animate-[bounce_2.5s_ease-in-out_infinite]"
        )}
        size="icon"
        aria-label="Ouvrir le chatbot"
      >
        <img 
          src={botsIcon} 
          alt="Chat" 
          className="h-full w-full object-contain"
        />
      </Button>
    </div>
  );
};

export default ChatbotButton;

